module.exports = "/images/arrow-left-grey.png?d2a9e6be5885de437cd2809c9b0ee5f4";